<template>
  <div
    :class="['NumbarPadOnscreenKeyboard']"
  >
    <div
      v-for="row in keyLayout"
      :key="row.name"
      class="row"
    >
      <touch-key
        v-for="key in row.keys"
        :key="key.name"
        :name="key.name"
        :character="key.character"
        :alt="key.alt"
        :shift="key.shift"
        :special="key.special"
        :hold-hand="key.hold"
        :row="row.name"
        :press="handleKeyDown"
        :release="handleKeyUp"
      >
        <span>{{key.character}}</span>
      </touch-key>
    </div>
  </div>
</template>

<script>
import { keyLayout } from 'constants/numberpad-keyboard';
import BaseKeyboard from 'mixins/BaseKeyboard';
import CommonAudio from 'mixins/CommonAudio';
import TouchKey from './keys/TouchKey.vue';

export default {
  name: 'NumberPadKeyboard',

  components: {
    TouchKey
  },

  mixins: [BaseKeyboard, CommonAudio],

  props: {
  },

  data() {
    return {
      keyLayout
    };
  },

  methods: {
    addKeyListeners() {
      window.addEventListener('keydown', this.handleKeyDown);
    },

    removeKeyListeners() {
      window.removeEventListener('keydown', this.handleKeyDown);
    },

    handleKeyDown(eventOrKeyCharacter) {
      const key = typeof eventOrKeyCharacter === 'object' ? eventOrKeyCharacter.key : eventOrKeyCharacter;

      if (!key.match(/^\d+|backspace|clear$/i)) {
        this.sndError();
        return;
      }

      this.attemptKey({ key });
    }
  }
};
</script>

<style lang="scss" scoped>
  .NumbarPadOnscreenKeyboard {
    width: 264px;
    border: 3px solid #000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 21px;
    gap: 8px;
    box-sizing: border-box;
    border-radius: 6px;

    *, *::before, *::after {
      box-sizing: inherit;
    }

    .row {
      display: flex;
      width: 100%;
      justify-content: space-between;
      gap: 11px;

      div {
        max-width: 65px;
        height: 40px;
        min-width: 65px;
        background: none;
        border: 2px solid #000;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding-top: 5px;
        font-size: 24px;
        font-weight: 600;
        border-radius: 6px;
        background: rgba(135, 203, 222, 1);
        opacity: 1;
      }
    }

    .row:last-child > :last-child {
      max-width: initial;
      flex-grow: 1;
      text-transform: uppercase;
      letter-spacing: 3px;
      background: rgba(212, 210, 225, 1);
    }

  }
</style>
